var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// - Import react components
import PrivateRoute from './PrivateRoute';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import Loadable from 'react-loadable';
import * as userActions from 'store/actions/userActions';
import MasterLoadingComponent from 'components/masterLoading/MasterLoadingComponent';
import HomeComp from 'containers/FrontPg';
// - Async Components
var AsyncStream = Loadable({
    loader: function () { return import('containers/stream'); },
    loading: MasterLoadingComponent,
});
var AsyncFrontStream = Loadable({
    loader: function () { return import('containers/FrontPgStream'); },
    loading: MasterLoadingComponent,
});
var AsyncProfile = Loadable({
    loader: function () { return import('containers/profile'); },
    loading: MasterLoadingComponent,
});
var AsyncClothingType = Loadable({
    loader: function () { return import('containers/ClothingType'); },
    loading: MasterLoadingComponent,
});
var AsyncPostPage = Loadable({
    loader: function () { return import('containers/postPage'); },
    loading: MasterLoadingComponent,
});
var AsyncPeople = Loadable({
    loader: function () { return import('containers/people'); },
    loading: MasterLoadingComponent,
});
var AsyncCheckout = Loadable({
    loader: function () { return import('containers/Checkout'); },
    loading: MasterLoadingComponent,
});
var AsyncMap = Loadable({
    loader: function () { return import('containers/map'); },
    loading: MasterLoadingComponent,
});
var AsyncPurchases = Loadable({
    loader: function () { return import('containers/Purchases'); },
    loading: MasterLoadingComponent,
});
var AsyncDesigner = Loadable({
    loader: function () { return import('containers/DesignerSignup'); },
    loading: MasterLoadingComponent,
});
var AsyncSuite = Loadable({
    loader: function () { return import('containers/Suite'); },
    loading: MasterLoadingComponent,
});
var AsyncManufacturer = Loadable({
    loader: function () { return import('containers/Manufacturers'); },
    loading: MasterLoadingComponent,
});
/**
 * Home Router
 */
var HomeRouter = /** @class */ (function (_super) {
    __extends(HomeRouter, _super);
    function HomeRouter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HomeRouter.prototype.componentDidMount = function () {
    };
    HomeRouter.prototype.render = function () {
        var _a = this.props, enabled = _a.enabled, match = _a.match, data = _a.data, translate = _a.translate;
        var St = AsyncStream;
        var FSt = AsyncFrontStream;
        // console.log('First', this.props.firstTime)
        return (enabled ? (React.createElement(Switch, null,
            React.createElement(PrivateRoute, { path: '/people/:tab?', component: React.createElement(AsyncPeople, null) }),
            React.createElement(PrivateRoute, { path: '/purchases', component: React.createElement(AsyncPurchases, null) }),
            React.createElement(PrivateRoute, { path: '/manufacturers', component: React.createElement(AsyncManufacturer, null) }),
            React.createElement(PrivateRoute, { path: '/map', component: React.createElement(AsyncMap, null) }),
            React.createElement(Route, { path: '/suite/:userId', component: AsyncSuite }),
            React.createElement(PrivateRoute, { path: '/feed', component: (React.createElement("div", null,
                    React.createElement(St, { homeTitle: translate('header.home'), posts: data.mergedPosts || data.searchedPosts, loadStream: data.loadDataStream, hasMorePosts: data.hasMorePosts, displayWriting: true, Main: 'New Arrivals', Secondary: 'Discover artists from around the globe' }))) }),
            React.createElement(PrivateRoute, { path: '/tag/:tag', component: (React.createElement("div", null,
                    React.createElement(St, { displayWriting: false, homeTitle: "#" + match.params.tag, posts: data.mergedPosts }))) }),
            React.createElement(Route, { path: '/designer/:Code?/', component: AsyncDesigner }),
            React.createElement(PrivateRoute, { path: '/', component: (React.createElement("div", null,
                    React.createElement(HomeComp, null))) })))
            : '');
    };
    return HomeRouter;
}(Component));
export { HomeRouter };
// - Map dispatch to props
var mapDispatchToProps = function (dispatch, ownProps) {
    return {
        openEditor: function () { return dispatch(userActions.openEditProfile()); },
    };
};
/**
 * Map state to props
 */
var mapStateToProps = function (state, ownProps) {
    var uid = state.getIn(['authorize', 'uid'], {});
    var userProfile = state.getIn(['user', 'info', uid], {});
    return {
        translate: getTranslate(state.get('locale')),
        currentLanguage: getActiveLanguage(state.get('locale')).code,
        firstTime: userProfile.firstTime
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HomeRouter));



//////////////////
// WEBPACK FOOTER
// ./src/routes/HomeRouter.tsx
// module id = 1484
// module chunks = 0 1 2 3